import { StatusDot } from '#components/atoms/icons/StatusDot.tsx';
import type { Host, HostStatus } from '#dn-types/host.ts';
import { getIpV6 } from '#util/hostIps.ts';
import styles from './HostCard.module.css';

type Props = { host: Host; status: HostStatus; className?: string };

// Purely presentational: GetStarted owns each host's live status (one polling observer per host)
// and passes the fresh host + computed status down.
export function HostCard({ host, status, className }: Props) {
  return (
    <div className={className ? `${styles.HostCard_card} ${className}` : styles.HostCard_card}>
      <div className={styles.HostCard_name}>
        <StatusDot status={status} />
        {host.name}
      </div>
      <div className={styles.HostCard_meta}>{getIpV6(host) ?? ''}</div>
    </div>
  );
}
